/**
 * The dashboard's top bar (DashboardNav), the same height at every screen size.
 * A page that fills the screen is this much shorter than the viewport.
 */
export const APP_BAR_HEIGHT = 56;
export const DASHBOARD_CONTENT_HEIGHT = `calc(100dvh - ${APP_BAR_HEIGHT}px)`;
